import { MessageBoxProps } from "../components/MessageBox";
import apiClient from "./client";

const WFM_API = "/wfm/api";

const getTicketDetails = async (id:number, email:string) => {
  const result = await apiClient.get<any>(`/wfm/work-order/ticket-tracking?ticketId=${id}&email=${email}`)
  return result
}

const getTicketHistory = async (id: number) =>
  await apiClient.get<any>(`/wfm/api/work-order/status-history?ticketId=${id}`);

interface ConversationResponse {
  success: boolean;
  data: MessageBoxProps[];
  _links: {
    self: {
      href: string;
    };
  };
  _meta: {
    totalCount: number;
    pageCount: number;
    currentPage: number;
    perPage: number;
  };
}

const fetchConversations = async (token: string, id: any, count:number, page:number) => {
  apiClient.setHeader("Authorization", `Bearer ${token}`);
  if(id) return await apiClient.get<ConversationResponse>(
    `${WFM_API}/work-order-conversations?filter[work_order_id]=${id}&page=${page}&per-page=${count}&sort=desc`
  );
};

export interface ConversationBody {
  request_payload: {
    ticket_id: string;
    body: string;
  };
  file?: File[];
}
const sendConversation = async (data: ConversationBody, token: string) => {
  apiClient.setHeader("Authorization", `Bearer ${token}`);
  apiClient.setHeader("Content-Type", "multipart/form-data");
  const formData = new FormData();
  formData.append("request_payload", JSON.stringify(data.request_payload));
  if (data.file) {
    data.file.forEach(file=>{
      formData.append("file[]", file);
    })
  }

  return await apiClient.post<{
    success: boolean;
    data: {
      message: string;
    };
  }>(`${WFM_API}/work-order-conversations`, formData);
};

const ticketApi = {
  fetchConversations,
  getTicketHistory,
  sendConversation,
  getTicketDetails
};

export default ticketApi;
